// src/components/AthleteDashboard/ZoneDistributionChart.jsx
import React, { useState } from 'react';
import axios from 'axios';
import { renderCompactZoneBlock } from '../../utils/zoneUtils';
import { useTranslation } from '../../i18n';
import API_BASE_URL from '../../config/api';

const ZoneDistributionChart = ({ userId, fileId }) => {
  const { t } = useTranslation();
  const [heartRateData, setHeartRateData] = useState([]);
  const [paceData, setPaceData] = useState([]);
  const [error, setError] = useState(null);

  React.useEffect(() => {
    const fetchZoneUsage = async () => {
      try {
        const fullFileId = fileId.endsWith('.fit') ? fileId : `${fileId}.fit`;
        const res = await axios.get(`${API_BASE_URL}/api/fit/zones-distribution/${userId}/${fullFileId}`);
        setHeartRateData(Array.isArray(res.data.heartRateZones) ? res.data.heartRateZones : []);
        setPaceData(Array.isArray(res.data.paceZones) ? res.data.paceZones : []);
      } catch (err) {
        console.error('Error al obtener distribución de zonas:', err);
        setError(t('athleteDashboard.zonesLoadingError'));
      }
    };
    if (userId && fileId) {
      fetchZoneUsage();
    }
  }, [userId, fileId, t]);

  if (error) return <p>{error}</p>;
  if (!heartRateData.length || !paceData.length) return <p>{t('athleteDashboard.zonesLoading')}</p>;

  return (
    <div className="zone-distribution-chart">
      <h3 style={{ color: '#193255', fontSize: 14, fontWeight: 700 }}>{t('athleteDashboard.zonesSummary')}</h3>
      <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', marginTop: 12 }}>
        {renderCompactZoneBlock(heartRateData, t('athleteDashboard.zonesHR'), t, 'zoneFC')}
        {renderCompactZoneBlock(paceData, t('athleteDashboard.zonesPace'), t, 'zoneVP')}
      </div>
    </div>
  );
};

export default ZoneDistributionChart;
